module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": _vm.back
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangzuo1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title ? _vm.title : '现场互动'))]), _vm._v(" "), (_vm.upload) ? _c('div', {
    ref: "pickfiles",
    staticClass: "right",
    attrs: {
      "id": "pickfiles"
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangjicopy"
    }
  })])]) : _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 15px",
      "width": "22px",
      "height": "40px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    attrs: {
      "position": "left"
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url('" + (_vm.user.Avatar) + "')")
    })
  }), _vm._v(" "), _c('h1', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.user.Nickname))])]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/home/index.html",
      "title": "云摄影主页"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/home/moreImg/index.html",
      "title": "更多活动现场"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/order/recruit.html",
      "title": "成为云摄影师"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/order/index.html",
      "title": "预约云摄影"
    }
  })], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2139a6bc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XHeader/XHeader.vue
// module id = 498
// module chunks = 1